import type { Command, CommandContext } from "./Command";
import { getComponent, withComponent } from "../../world/Entity";
import type { EntityId } from "../../world/Entity";
import type { ClothingSlot } from "../../world/components";
import type { InventoryCategory, InventoryItem } from "../../inventory/Inventory";

/** Counterpart to {@link EquipItemCommand}: returns a worn item to the inventory. */
export class UnequipItemCommand implements Command {
  constructor(
    private readonly characterId: EntityId,
    private readonly slot: ClothingSlot,
    private readonly category: InventoryCategory = "clothing",
  ) {}

  execute(context: CommandContext): void {
    const character = context.world.getEntity(this.characterId);
    if (!character) throw new Error(`Unknown character "${this.characterId}"`);
    const characterComponent = getComponent(character, "character");
    const definitionId = characterComponent?.clothing[this.slot];
    if (!definitionId) return;

    context.world.updateEntity(this.characterId, (e) =>
      withComponent(e, "character", (c) => {
        const clothing = { ...c.clothing };
        delete clothing[this.slot];
        return { ...c, clothing };
      }),
    );
    const definition = context.world.getEntityDefinition(definitionId);
    const item: InventoryItem = {
      instanceId: crypto.randomUUID(),
      definitionId,
      quantity: 1,
      category: this.category,
      stackable: false,
      favorite: false,
      ...(definition ? { metadata: { kind: definition.kind, components: definition.components } } : {}),
    };
    context.world.addToInventory(item);
    context.events.emit("character:undressed", { characterId: this.characterId, slot: this.slot });
  }
}
